

window.resetValues = function(obj){
	let i;
	for (i in obj){
		if(typeof(obj[i])=='string') obj[i] = '';
		if(typeof(obj[i])=='object') obj[i] = resetValues(obj[i]);
		//if(typeof(val)=='number') return 0
	}
	return obj;
}
window.clone = function(obj){
	return JSON.parse(JSON.stringify(obj))
}
window.extractUrl = function(string){

	var match = string.match(/url\(([^)]+)\)/i);
	if(match) return match.pop();
	var match = string.match(/^https?:\/\/[^\s]+/i);
	if(match) return match.pop();
	return '';
}


window.isMobile = function(){
	if(window.navigator.userAgent.match(/Android/i)) return true;
	if(window.navigator.userAgent.match(/iPhone|iPad/i)) return true;
	return false;
}



window.uniqid = function(prefix){
  var str = ''
  if(prefix) str = prefix;
  var charcode = Math.floor(Math.random() * 26) + 97; // a-z
  str+=String.fromCharCode(charcode);
  str+=Math.floor(Math.random() * 1000000);
  str+=new Date().getTime()
  return str;
}

window.json_encode = function(obj){
	return JSON.stringify(obj,null,"\t");

}